import { httpClient } from './client';

export type PurchaseShipmentVolumePayload = {
  quantity: number;
};

export const purchaseShipmentVolume = async (payload: PurchaseShipmentVolumePayload): Promise<void> => {
  await httpClient.post('/account/purchaseVolume', payload);
};
